export const urlWith = (url: string, params: Record<string, string>) => {
  return Object.keys(params).length ? `${url}${setParams(params)}` : url;
};

export const urlWithProtocol = (url: string) =>
  /^https?:\/\/.+/.test(url) ? url : 'https://' + url;

export const setParams = (data: { [key: string]: string }) => {
  return `?${new URLSearchParams(data).toString()}`;
};
export const getParams = (text: string) => new URLSearchParams(text);

export const phpApiParamsSerializer = (params: Record<string, any>) => {
  const pairs = [];

  for (const [key, value] of Object.entries(params)) {
    if (Array.isArray(value)) {
      // Handle arrays with PHP-style format: foo[]=1&foo[]=2
      for (const item of value) {
        pairs.push(`${encodeURIComponent(key)}[]=${encodeURIComponent(item)}`);
      }
    } else if (value !== null && value !== undefined) {
      // Handle regular key-value pairs
      pairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    }
  }

  return pairs.join('&');
};
